/* eslint-disable */
import * as React from 'react';
import gql from 'graphql-tag';
// Fetch Polyfill for apollo-client
// https://github.com/apollographql/apollo-client/issues/2780
import 'isomorphic-unfetch';
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, concat } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import cookie from 'cookie';
import { USER_DETAILS } from './constants/queries';

let ANALYTICS_API_TOKEN = false;
let ANALYTICS_API_TYPE = false;

const getToken = () => {
  const cookieName = process.env.REACT_APP_SESS_KEY;
  return cookie.parse(document.cookie)[cookieName];
};

const getAnalyticsAuthorization = () => {
  if (false === ANALYTICS_API_TOKEN) {
    try {
      const cacheUser = client.readQuery({ query: gql(USER_DETAILS) });
      if (cacheUser) {
        ANALYTICS_API_TOKEN = cacheUser.properties.user.apitoken.access_token;
        ANALYTICS_API_TYPE = cacheUser.properties.user.apitoken.token_type;
      }
    } catch (error) {
      return '';
    }
  }
  return `${ANALYTICS_API_TYPE} ${ANALYTICS_API_TOKEN}`;
};

const envMiddleware = new ApolloLink((operation: any, forward: any) => {
  /**
   * Some hack her
   * So we need to pass two different authroization headers
   * One for youvisit.com/api... and one for analytics.youvisit.com/...
   * So we pass the api, with suffic _API
   */
  let token = getToken();

  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      env: process.env.REACT_APP_BACKEND_API_ENVIRONMENT,
      Authorization: `Bearer ${token}`,
      'Authorization-API': getAnalyticsAuthorization(),
      ...headers,
    },
  }));

  return forward(operation);
});

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPHQL });
const cache = new InMemoryCache();
export const client = new ApolloClient({
  // By default, this client will send queries to the
  //  `/graphql` endpoint on the same host
  // Pass the configuration option { uri: YOUR_GRAPHQL_API_URL } to the `HttpLink` to connect
  // to a different host
  link: concat(envMiddleware, httpLink),
  cache,
});

const ApolloRootProvider: React.FC<any> = props => {
  return <ApolloProvider client={client}>{props.children}</ApolloProvider>;
};

export default ApolloRootProvider;
try {
    // @ts-ignore
    apolloRootProvider.displayName = "apolloRootProvider";
    // @ts-ignore
    apolloRootProvider.__docgenInfo = { "description": "", "displayName": "apolloRootProvider", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Apollo/apolloRootProvider.tsx#apolloRootProvider"] = { docgenInfo: apolloRootProvider.__docgenInfo, name: "apolloRootProvider", path: "src/shared/hoc/Apollo/apolloRootProvider.tsx#apolloRootProvider" };
}
catch (__react_docgen_typescript_loader_error) { }